import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { Calendar, Clock, ArrowLeft, UserRound } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmtDate = (s) => {
  if (!s) return "";
  try {
    return new Date(s).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return s;
  }
};

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API}/blogs/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="max-w-3xl mx-auto px-5 py-32 text-brand-ink/60">Loading…</div>;
  if (error || !post)
    return (
      <div className="max-w-3xl mx-auto px-5 py-32 text-center" data-testid="blog-not-found">
        <h1 className="font-serif-display text-3xl text-brand-ink">Article not found</h1>
        <Link to="/blog" className="mt-6 inline-block text-brand-maroon font-semibold">← Back to blog</Link>
      </div>
    );

  return (
    <article data-testid="blog-detail-page" className="bg-white">
      <div className="max-w-4xl mx-auto px-5 md:px-10 pt-12 md:pt-16">
        <Link
          to="/blog"
          data-testid="blog-back-link"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-maroon hover:underline"
        >
          <ArrowLeft size={15} /> Back to blog
        </Link>
        <div className="mt-6 text-xs uppercase tracking-[0.22em] font-bold text-brand-maroon">{post.category}</div>
        <h1 className="mt-3 font-serif-display text-3xl md:text-5xl text-brand-ink leading-[1.1]">{post.title}</h1>
        <div className="mt-5 flex flex-wrap items-center gap-5 text-sm text-brand-ink/60">
          <span className="inline-flex items-center gap-2"><UserRound size={14} /> {post.author}</span>
          <span className="inline-flex items-center gap-2"><Calendar size={14} /> {fmtDate(post.published_at)}</span>
          <span className="inline-flex items-center gap-2"><Clock size={14} /> {post.read_time}</span>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-5 md:px-10 mt-10">
        <div className="rounded-3xl overflow-hidden aspect-[16/8]">
          <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-5 md:px-10 py-12 prose-fhc">
        <div dangerouslySetInnerHTML={{ __html: post.content }} />
      </div>
    </article>
  );
}
